import './Bylaws.css'

export default function Bylaws(){

    return(

        <main>

            <div className='outerBox'>

                <h1>Co-op Bylaws</h1>

                <div className="bylawInnerBox">

                    <div class="bylaw-link-grid">

                        <a href="https://drive.google.com/file/d/1QRAUR8gcFJmsRZz1MceDOyRiLyDcoe4p/view?usp=drive_link" 
                            alt="Bylaw1" target="_blank" rel="noreferrer">
                            Bylaw 1 - Empowerment of the Board
                        </a>

                        <a href="https://drive.google.com/file/d/1TY809Zg395COzRKKKVQP8cP0QEibH-6i/view?usp=drive_link"
                            alt="Bylaw2" target="_blank" rel="noreferrer">
                            Bylaw 2 - Borrowing Powers
                        </a>

                        <a href="https://drive.google.com/file/d/18isSg6-dsLgeeAEOAI6T9rsPXMa5ht4e/view?usp=drive_link"
                            alt="Bylaw3" target="_blank" rel="noreferrer">
                            Bylaw 3 - Occupancy
                        </a>

                        <a href="https://drive.google.com/file/d/1L05x0JjAKnSrVNFFjRb4USA43LEw05TW/view?usp=drive_link"
                            alt="Bylaw4" target="_blank" rel="noreferrer">
                            Bylaw 4 - Organizational
                        </a>

                        <a href="https://drive.google.com/file/d/1WdLQnlhUhm6_FCQCdv24igOTDmZ5DIu4/view?usp=drive_link"
                            alt="Bylaw5" target="_blank" rel="noreferrer">
                            Bylaw 5 - Arrears
                        </a>

                        <a href="https://drive.google.com/file/d/1t2VlRzt-bgpr251ysw-w3leAzgwQdeSG/view?usp=drive_link"
                            alt="Bylaw6" target="_blank" rel="noreferrer">
                            Bylaw 6 - Member Reloaction
                        </a>

                        <a href="https://drive.google.com/file/d/1_XkCNrYQ-LfcwpbYV5t_KBO42smN6ym1/view?usp=drive_link"
                            alt="Bylaw7" target="_blank" rel="noreferrer">
                            Bylaw 7 - Maintenance
                        </a>

                        <a href="https://drive.google.com/file/d/1DPdM1xnDu0-HfgwHH14LWj5NwrYE6tn1/view?usp=drive_link"
                            alt="Bylaw8" target="_blank" rel="noreferrer">
                            Bylaw 8 - Parking
                        </a>

                        <a href="https://drive.google.com/file/d/1EcThmOAZKwkVEdEzUlKqqXidFqUpyhay/view?usp=drive_link"
                            alt="Bylaw9" target="_blank" rel="noreferrer">
                            Bylaw 9 - External Waiting List
                        </a>

                        <a href="https://drive.google.com/file/d/1CssDlFhWb3X8ymvaVxi9MmVhw2_QZdqH/view?usp=drive_link"
                            alt="Bylaw10" target="_blank" rel="noreferrer">
                            Bylaw 10 - Pet
                        </a>

                        <a href="https://drive.google.com/file/d/1jOgWjlr6NGPJv6Kn0UqGMKK89qtTWNHO/view?usp=drive_link"
                            alt="Bylaw11" target="_blank" rel="noreferrer">
                            Bylaw 11 - Amendment to Member Relocation Bylaw No.6
                        </a>

                        <a href="https://drive.google.com/file/d/1JLuCe6K0jiYYoW2DKKL-Af67HezyG_IF/view?usp=drive_link"
                            alt="Bylaw12" target="_blank" rel="noreferrer">
                            Bylaw 12 - Amendment to Maintenance Bylaw No. 7
                        </a>

                        <a href="https://drive.google.com/file/d/16EAIvRO1MgXm35iFLFTeGxEtznAOHan7/view?usp=drive_link"
                            alt="Bylaw13" target="_blank" rel="noreferrer">
                            Bylaw 13 - Amendment to Occupancy Bylaw No. 3
                        </a>

                        <a href="https://drive.google.com/file/d/10ZfltjHo2YukKR4U1gjsC4XQqmtwLqwh/view?usp=drive_link"
                            alt="Bylaw14" target="_blank" rel="noreferrer">
                            Bylaw 14 - Amendment to Organizational Bylaw No. 4
                        </a>

                        <a href="https://drive.google.com/file/d/1EEZNcwRCP9jK9aYOTCUwxdr1suERYjTG/view?usp=drive_link"
                            alt="Bylaw15" target="_blank" rel="noreferrer">
                            Bylaw 15 - Amendment to Occupancy Bylaw No. 3
                        </a>

                        <a href="https://drive.google.com/file/d/1ePEGBagvWYQf76HPCBN5IJyBcotm2U6_/view?usp=drive_link"
                            alt="Bylaw16" target="_blank" rel="noreferrer">
                            Bylaw 16 - Social Housing Reform Act Bylaw
                        </a>

                        <a href="https://drive.google.com/file/d/1GEjXpUS55ha365WPcGPFDDcwIFgzYetP/view?usp=drive_link"
                            alt="Bylaw17" target="_blank" rel="noreferrer">
                            Bylaw 17 - Membership Approval & Unit Allocation Bylaw
                        </a>

                        <a href="https://drive.google.com/file/d/1cSo42Cec1QwgJGIhr9gsHvJrNOZZ1l2e/view?usp=drive_link"
                            alt="Bylaw18" target="_blank" rel="noreferrer">
                            Bylaw 18 - Confidentiality Bylaw
                        </a>

                        <a href="https://drive.google.com/file/d/1DaZIRLigudPPEeID-wBTB9muWZSQ_Pmx/view?usp=drive_link"
                            alt="Bylaw19" target="_blank" rel="noreferrer">
                            Bylaw 19 - Arrears bylaw
                        </a>
                    </div>

                    
                </div>
                
            </div>

        </main>
    )
}